import { render, staticRenderFns } from "./WorkAccomplishment.vue?vue&type=template&id=66f2c10f&"
import script from "./WorkAccomplishment.vue?vue&type=script&lang=js&"
export * from "./WorkAccomplishment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports